import {app} from '../app';
import IScope = angular.IScope;
import {SharedQuestion} from "../sharedQuestions/SharedQuestion";

export class QuestionContainerComponent {

    sharedQuestion:SharedQuestion;
    hideTitle:any;

    $onInit() {
        this.hideTitle = this.hideTitle === "true";
    }

}

app.component('questionContainer', {
    templateUrl: 'templates/components/questionContainer.html',
    controller: QuestionContainerComponent,
    controllerAs: 'questionContainer',
    transclude: true,
    bindings: {
        sharedQuestion: '<',
        hideTitle: '@',
    }
});